<script>
import BaseLisitng from '../../../share/ListingWithEditMode'
import clientObjectMixin from '../../share/mixins/clientObjectMixin'

export default {
  mixins: [
    BaseLisitng,
    clientObjectMixin
  ],
  data () {
    return {
      service: this.$route.params.service,
      headerTitle: { title: 'Mapa przejść', description: 'Lista' },
      editModeUrlName: '',
      gridDataSource: null,
      gridName: 'grid_transition',
      editEventName: ''
    }
  },
  computed: {
    gridColumns() {
      return [
        {
          id: 0,
          data: 'DT_RowId',
          title: '',
          searchable: false,
          orderable: false,
          render: () => { return '' }
        },
        { id: 1, data: 'name', title: 'Nazwa' },
        { id: 2, data: 'fromState', title: 'Status początkowy' },
        { id: 3, data: 'toState', title: 'Status końcowy' },
        { id: 4, data: 'role', title: 'Rola' }
      ]
    }
  },
  created () {
    this.getInitEditModeUrlName()
    this.getInitEditEventName()
    this.getInitGridDataSource()
  },
  methods: {
    getInitEditModeUrlName () {
      this.editModeUrlName = `${this.service}_transition_edit`
    },
    getInitEditEventName () {
      this.editEventName = `${this.service}:main:transitionEdit`
    },
    getInitGridDataSource () {
      this.gridDataSource = { service: this.service, url: `/workflows/${this.$getCategoryNew(this.clientObject, this.$route.params.taskCategoryId).workflows[0].id}/transitions` }
    }
  }
}
</script>
